import React from 'react'
import "./About.css"
import { IoBagHandleSharp } from "react-icons/io5";
import { FaMedal } from "react-icons/fa";
export const About = () => {
  return (
    <div class="hero">

      <div class="snow">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1536" preserveAspectRatio="xMidYMax slice">
          <g fill="#FFF" fill-opacity=".15" transform="translate(55 42)">
            <g id="snow-bottom-layer">
              <ellipse cx="6" cy="1009.5" rx="6" ry="5.5" />
              <ellipse cx="138" cy="1110.5" rx="6" ry="5.5" />
              <ellipse cx="398" cy="1055.5" rx="6" ry="5.5" />
              <ellipse cx="719" cy="1284.5" rx="6" ry="5.5" />
              <ellipse cx="760" cy="1155.5" rx="6" ry="5.5" />
              <ellipse cx="635" cy="1459.5" rx="6" ry="5.5" />
              <ellipse cx="478" cy="1335.5" rx="6" ry="5.5" />
              <ellipse cx="322" cy="1414.5" rx="6" ry="5.5" />
              <ellipse cx="247" cy="1234.5" rx="6" ry="5.5" />
              <ellipse cx="154" cy="1425.5" rx="6" ry="5.5" />
              <ellipse cx="731" cy="773.5" rx="6" ry="5.5" />
              <ellipse cx="599" cy="874.5" rx="6" ry="5.5" />
              <ellipse cx="339" cy="819.5" rx="6" ry="5.5" />
              <ellipse cx="239" cy="1004.5" rx="6" ry="5.5" />
              <ellipse cx="113" cy="863.5" rx="6" ry="5.5" />
              <ellipse cx="102" cy="1223.5" rx="6" ry="5.5" />
              <ellipse cx="395" cy="1155.5" rx="6" ry="5.5" />
              <ellipse cx="826" cy="943.5" rx="6" ry="5.5" />
              <ellipse cx="626" cy="1054.5" rx="6" ry="5.5" />
              <ellipse cx="887" cy="1366.5" rx="6" ry="5.5" />
              <ellipse cx="6" cy="241.5" rx="6" ry="5.5" />
              <ellipse cx="138" cy="342.5" rx="6" ry="5.5" />
              <ellipse cx="398" cy="287.5" rx="6" ry="5.5" />
              <ellipse cx="719" cy="516.5" rx="6" ry="5.5" />
              <ellipse cx="760" cy="387.5" rx="6" ry="5.5" />
              <ellipse cx="635" cy="691.5" rx="6" ry="5.5" />
              <ellipse cx="478" cy="567.5" rx="6" ry="5.5" />
              <ellipse cx="322" cy="646.5" rx="6" ry="5.5" />
              <ellipse cx="247" cy="466.5" rx="6" ry="5.5" />
              <ellipse cx="154" cy="657.5" rx="6" ry="5.5" />
              <ellipse cx="731" cy="5.5" rx="6" ry="5.5" />
              <ellipse cx="599" cy="106.5" rx="6" ry="5.5" />
              <ellipse cx="339" cy="51.5" rx="6" ry="5.5" />
              <ellipse cx="239" cy="236.5" rx="6" ry="5.5" />
              <ellipse cx="113" cy="95.5" rx="6" ry="5.5" />
              <ellipse cx="102" cy="455.5" rx="6" ry="5.5" />
              <ellipse cx="395" cy="387.5" rx="6" ry="5.5" />
              <ellipse cx="826" cy="175.5" rx="6" ry="5.5" />
              <ellipse cx="626" cy="286.5" rx="6" ry="5.5" />
              <ellipse cx="887" cy="598.5" rx="6" ry="5.5" />
            </g>
          </g>
          <g fill="#FFF" fill-opacity=".3" transform="translate(65 63)">
            <g id="snow-top-layer">
              <circle cx="8" cy="776" r="8" />
              <circle cx="189" cy="925" r="8" />
              <circle cx="548" cy="844" r="8" />
              <circle cx="685" cy="1115" r="8" />
              <circle cx="858" cy="909" r="8" />
              <circle cx="874" cy="1438" r="8" transform="rotate(180 874 1438)" />
              <circle cx="657" cy="1256" r="8" transform="rotate(180 657 1256)" />
              <circle cx="443" cy="1372" r="8" transform="rotate(180 443 1372)" />
              <circle cx="339" cy="1107" r="8" transform="rotate(180 339 1107)" />
              <circle cx="24" cy="1305" r="8" transform="rotate(180 24 1305)" />
              <circle cx="8" cy="8" r="8" />
              <circle cx="189" cy="157" r="8" />
              <circle cx="548" cy="76" r="8" />
              <circle cx="685" cy="347" r="8" />
              <circle cx="858" cy="141" r="8" />
              <circle cx="874" cy="670" r="8" transform="rotate(180 874 670)" />
              <circle cx="657" cy="488" r="8" transform="rotate(180 657 488)" />
              <circle cx="443" cy="604" r="8" transform="rotate(180 443 604)" />
              <circle cx="339" cy="339" r="8" transform="rotate(180 339 339)" />
              <circle cx="24" cy="537" r="8" transform="rotate(180 24 537)" />
            </g>
          </g>
        </svg>
      </div>
      <div>
        <div className='head-container'>
          <h1 className='name'>Tekumudi Bala Surya Narayana Murthy</h1>
          <p className='role-2'>|| Frontend developer 🧡 React 💙 Javascript 💛||</p>
        </div>
        <div className='about-container'>
          <h3 className='role-2 about'>About</h3>
          <button className='know-button'><IoBagHandleSharp /> Open to Work</button>
        </div>
        <p className='description des-2'>I am passionate about staying updated with the latest trends and technologies in frontend 
        development. I enjoy learning new tools and techniques that enhance user experiences
         and streamline development processes. I am excited about the opportunity to
          collaborate with like-minded professionals and contribute to impactful projects
           that make a difference.I am enthusiastic about starting my journey as a frontend developer, leveraging my skills and passion to create visually appealing, responsive, 
           and user-friendly web applications. I am eager to learn, grow, and make meaningful contributions
            to innovative projects. Let's build amazing experiences together!</p>
          <div className='choose-container'>
          <div>
            <img src="https://ravipanthuladev.web.app/static/media/choosen.01e5963756157026c1b0.png" alt="whychoose" className='study for-mobile'/>
           </div>
            <div>
              <h3 className='why-choose'>Why choosing me</h3>
            <button className='whyChoosingMePoints'><FaMedal className='medal' /> Solid Experience with Javascript</button><br/>
            <button className='whyChoosingMePoints'><FaMedal className='medal' />  Continuous Learning and Adaptability</button><br/>

            <button className='whyChoosingMePoints'><FaMedal className='medal' /> Passion for Development</button><br/>

            <button className='whyChoosingMePoints'><FaMedal className='medal' /> Problem-Solving Abilities</button><br/>
            <button className='whyChoosingMePoints'> <FaMedal className='medal' />Collaboration and Teamwork</button>
            </div>
           <div>
            <img src="https://ravipanthuladev.web.app/static/media/choosen.01e5963756157026c1b0.png" alt="whychoose" className='study for-web'/>
           </div>

          </div>
          <div className='choose-container'>
          <div>
            <img src="https://ravipanthuladev.web.app/static/media/education.bb6f6562afa46fc3bebf57ec33f57421.svg" alt="study" className='study'/>
          </div>
          <div>
          <h3 className='why-choose'>Education</h3>
            <div className='card-container-1'>
              <div>
            <p className='college'>Vsm College Ramachandrapuram</p>
            <p className='role-2'>Bsc Computers</p>
            </div>
            <div>
              <div>
              <img src="https://ravipanthuladev.web.app/static/media/edu1.dddf93efa623d0d28e32.png" alt="logo" className='logo'/>
              </div>
              <p className='role-2'>2018 - 2021</p>
            </div>
            </div>
            <div className='card-container-1'>
              <div>
            <p className='college'>Government Junior College Pamarru</p>
            <p className='role-2'>MPC</p>
            </div>
            <div>
              <div>
              <img src="https://ravipanthuladev.web.app/static/media/edu1.dddf93efa623d0d28e32.png" alt="logo" className='logo'/>
              </div>
              <p className='role-2'>2016 - 2018</p>
            </div>
            </div>
             <div className='card-container-1'>
              <div>
            <p className='college'>ZPHS School Kurmapuram</p>
            <p className='role-2'>SSC</p>
            </div>
            <div>
              <div>
              <img src="https://ravipanthuladev.web.app/static/media/edu1.dddf93efa623d0d28e32.png" alt="logo" className='logo'/>
              </div>
              <p className='role-2'>2015 - 2016</p>
            </div>
          </div>
          </div>
      </div>
      <div className='choose-container'>
          <div>
          <h3 className='why-choose'>About my skills</h3>
            <button className='skil-button'>HTML5</button>
            <button  className='skil-button'>CSS3</button>            
            <button  className='skil-button'>Javascript</button>
            <button  className='skil-button'>Python</button>
          </div>
          <div className='skill-con'>
            <img src="https://res.cloudinary.com/dwsxbsjdc/image/upload/v1710844926/sk_4_tetx9h.png" alt="skills" className='skills'/>
          </div>
          </div>
          
      </div>
      <div>
        <h2 className='interested-role'>Interested roles</h2>
        <div className='roles-container'>
        <div className='role-card'>
          <p className='role-2'>Frontend developer</p>
          <p className='role-2 '>Hyd | Remote</p>
        </div>
        <div className='role-card'>
          <p className='role-2'>React developer</p>
          <p className='role-2 '>Hyd | Remote</p>
        </div>
        <div className='role-card'>
          <p className='role-2'>Web developer</p>
          <p className='role-2 '>Hyd | Remote</p>
        </div>
      </div>
      </div>
      </div>
  )
}
